if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      const hiddenIdInput = this.form.querySelector('[type=hidden][name=id]');
      if (hiddenIdInput) hiddenIdInput.disabled = false;

      if (!this._submitBound) {
        this._submitBound = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this._submitBound);
      }

      this.cart = this.getCart();

      this.submitButton = this.querySelector('[type="submit"]');
      if (this.cart && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cart = this.getCart();

      if (this.cart && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton?.setAttribute('aria-disabled', true);
      this.submitButton?.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Ensure the hidden id input is always enabled before building FormData
      const hiddenIdInput = this.form.querySelector('[name=id]');
      if (hiddenIdInput) hiddenIdInput.disabled = false;

      const formData = new FormData(this.form);

      if (this.cart?.getSectionsToRender) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.section || section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement?.(document.activeElement);
      } else if (this.cart) {
        this.cart.setActiveElement?.(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.renderCartContents(response);
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.renderCartContents(response);
          }
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton?.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) this.submitButton?.removeAttribute('aria-disabled');

          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    renderCartContents(response) {
      this.cart = this.getCart();

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (this.cart.renderContents && response.sections) {
        this.cart.renderContents(response);
        return;
      }

      if (this.cart.update) {
        this.cart.update();
        return;
      }

      window.location = window.routes.cart_url;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
